import Socials from './Socials';

function HomePage() {
  return (
    <div className="HomePage-container">
      <h1 className="HomePage-title">Thiago Carvalho</h1>
      <Socials />
    </div>
  );
}

export default HomePage;